import { mapGetters } from 'vuex';

import ContentType from '@/helpers/contentType';
import CategoryType from '@/helpers/contentCategory';
import { getParentOfSelectedTopic } from '@/helpers/tree';

import TaskRender from '@/components/content-management/task/render/student';
import HtmlRenderContainer from '@/components/content-management/html-render-container';
import LinkGroupRenderContainer from '@/components/content-management/link-group-render-container';
import ConferenceRender from '@/components/content-management/webconference/render/student';
import LTIRender from '@/components/content-management/lti/wrapper-render';
import QuizRender from '@/components/content-management/quiz/render/student';
import ForumPreview from '@/components/gaia/modals/forum-preview';

import MarkProgressBtn from '@/components/gaia/student/mark-progress-btn';

const renders = {
  [CategoryType.HTML]                : HtmlRenderContainer,
  [CategoryType.DISCURSIVE_EXERCISE] : TaskRender,
  [CategoryType.LINKS]               : LinkGroupRenderContainer,
  [CategoryType.WEBCONFERENCE]       : ConferenceRender,
  [CategoryType.LTI]                 : LTIRender,
  [CategoryType.EXERCISE]            : QuizRender,
  [CategoryType.FORUM]               : ForumPreview
};

export default {
  components: {
    TaskRender,
    HtmlRenderContainer,
    LinkGroupRenderContainer,
    ConferenceRender,
    MarkProgressBtn
  },
  data() {
    return {
      isEditing  : false,
      isEditable : false
    };
  },
  props: {
    items: {
      type: Object
    },
    styles: {
      type: Object
    }
  },
  computed: {
    ...mapGetters({
      getterMenuTopics: 'plataforma/content/getterMenuTopics'
    }),
    comp() {
      return renders[this.items.categoryTypeId];
    },
    rootMargin() {
      const height = window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
      return `-98px 0px -${height - 170}px 0px`;
    },
    props() {
      if (this.items.topicTypeId === ContentType.FORUM) {
        return {
          title   : this.items.title,
          content : {
            ...this.items.content,
            enrollmentIdsWhoLiked: this.items.enrollmentIdsWhoLiked
          }
        };
      } else if (this.items.topicTypeId === ContentType.LTI) {
        return {
          title   : this.items.title,
          content : {
            ...this.items.content,
            hasDeadline : this.items.hasDeadline,
            deadlineAt  : this.items.deadlineAt
          }
        };
      } else {
        return {
          title   : this.items.title,
          content : this.items.content
        };
      }
    },
    contentTypeComputed() {
      return ContentType;
    },
    topicParent() {
      return getParentOfSelectedTopic(this.getterMenuTopics, this.items);
    }
  },
  methods: {
    emitForum() {
      this.$nuxt.$emit('student-section', {
        type : 'openForum',
        data : this.items
      });
    },
    onIntersect(entries, _, isIntersecting) {
      if (isIntersecting) {
        this.$nuxt.$emit('student-section', {
          type : 'changeViewedTopic',
          data : Number(entries[0].target.dataset.id)
        });
      }
    }
  }
};
